import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable,Subject,BehaviorSubject } from "rxjs";

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiCompanyService extends FvmsApiBaseService {
    subjCompanyEvent:BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    //보관중인 마지막값을 리턴
    getCompanyEvent(){
        return this.subjCompanyEvent.getValue();
    }
    //마지막 값을 설정 -> 구독중인 모든 컴포넌트가 각자 행동취함
    setCompanyEvent(companyInfo:any){
        this.subjCompanyEvent.next(companyInfo);
    }
    //구독
    subscribeCompanyEvent():Observable<any>{
        return this.subjCompanyEvent.asObservable();
    }

    getListCompanyTree(companyId:any,searchValue:string):Observable<any>{
        let url = this.getApiBaseUrl() + "/company";
        url += "/tree/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpSearchInfo = {
            "companyId":companyId
            ,"searchValue":searchValue
        };
        let tmpPostObject = {
            "searchInfo":tmpSearchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListCompanyTreeRecursive(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/company";
        url += "/tree/list/recursive";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getOneCompanyTree(companyId:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/company";
        url += "/tree/one";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpSearchInfo = {
            "companyId":companyId
        };
        let tmpPostObject = {
            "searchInfo":tmpSearchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    findAllCompanyLcs(companyId:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/company";
        url += "/manage/lcs/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpSearchInfo = {
            "companyId":companyId
        };
        let tmpPostObject = {
            "searchInfo":tmpSearchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    upsertCompanyInfo(companyInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/company";
        url += "/manage/upsert";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":companyInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    deleteCompanyInfo(companyInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/company";
        url += "/manage/delete";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":companyInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    updateEtasLoginPw(companyInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/company";
        url += "/manage/etas/login/pw/update";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":companyInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    findAllEtasCarPaging(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/company";
        url += "/manage/etas/car/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    upsertEtasCar(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/company";
        url += "/manage/etas/car/upsert";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }
}